
import storage from './storage'

const booleanOptions = [
  {
    value: false,
    label: "否"
  },
  {
    value: true,
    label: "是"
  }
]

const booleanOptionsNum = [
  {
    value: 0,
    label: "否"
  },
  {
    value: 1,
    label: "是"
  }
]

const langOptions = [
  {
    value: "zh_CN",
    label: "中文"
  },
  {
    value: "en_US",
    label: "英文"
  },
]

const getCurrentDate = () => {
  return new Date(getCurrentTimeStamp());
}

const getCurrentTimeStamp = () => {

  var date = new Date();
  var time_zone = 8;
  var offset_GMT = date.getTimezoneOffset();
  var nowDate = date.getTime();

  return nowDate + offset_GMT * 60 * 1000 + time_zone * 60 * 60 * 1000;
}


const getBlockExplorer = (symbol) => {
  if (symbol == null || symbol == undefined) {
    return "";
  }
  let blockExplorer;
  switch (symbol.trim().toUpperCase()) {
    case "ETH":
      blockExplorer = "https://cn.etherscan.com";
      break;
    case "YITAIFANG":
      blockExplorer = "https://www.yitaifang.com";
      break;
    default:
      blockExplorer = "";
      break;
  }
  return blockExplorer;
}


const getBlockExplorerTx = (symbol, txid) => {
  if (symbol == null || symbol == undefined || txid == null || txid == undefined) {
    return "";
  }
  let blockExplorer = getBlockExplorer(symbol);
  let blockExplorerTx;
  switch (symbol.trim().toUpperCase()) {
    case "ETH":
      blockExplorerTx = blockExplorer + "/tx/" + txid;
      break;
    case "YITAIFANG":
      blockExplorerTx = blockExplorer + "/txs/" + txid;
      break;
    default:
      blockExplorerTx = "";
      break;
  }
  return blockExplorerTx;
}


const getBlockExplorerAddress = (symbol, address) => {
  if (symbol == null || symbol == undefined || address == null || address == undefined) {
    return "";
  }
  let blockExplorer = getBlockExplorer(symbol);
  let blockExplorerAddress;
  switch (symbol.trim().toUpperCase()) {
    case "ETH":
      blockExplorerAddress = blockExplorer + "/address/" + address;
      break;
    case "YITAIFANG":
      blockExplorerTx = blockExplorer + "/accounts/" + address;
      break;
    default:
      blockExplorerAddress = "";
      break;
  }
  return blockExplorerAddress;
}

const getBlockExplorerAddressToken = (symbol, address) => {
  if (symbol == null || symbol == undefined || address == null || address == undefined) {
    return "";
  }
  let blockExplorer = getBlockExplorer(symbol);
  let blockExplorerAddress;
  switch (symbol.trim().toUpperCase()) {
    case "ETH":
      blockExplorerAddress = blockExplorer + "/address/" + address + '#tokentxns';
      break;
    case "YITAIFANG":
      blockExplorerAddress = blockExplorer + "/accounts/" + address + '#tab2';
      break;
    default:
      blockExplorerAddress = "";
      break;
  }
  return blockExplorerAddress;
}

const getToken = () => {
  return storage.get('at');
}

const getPreKey = () => {
  let preKey = getToken();
  return preKey == null || preKey == undefined ? "default" : preKey.replace("bearer ", "").replaceAll("-", "");
}


export default {
  booleanOptions,
  booleanOptionsNum,
  langOptions,
  getCurrentDate,
  getCurrentTimeStamp,
  getBlockExplorer,
  getBlockExplorerTx,
  getBlockExplorerAddress,
  getBlockExplorerAddressToken,
  getToken,
  getPreKey
}



// WEBPACK FOOTER //
// ./src/models/commonData.js